module.exports = __webpack_public_path__ + "static/media/drinks.e1a35534.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/drinks.jpg
// module id = 640
// module chunks = 0